"use client";

import PixelArrow from "@/assets/icons/tsx/PixelArrow";
import React from "react";

interface PriceInfoItemProps {
  title: string;
  content: string; // HTML string with colored spans
}

// Dummy data with HTML markup for colored text
// Colors: text-accent-gold for prices, text-accent-green for positive %, text-accent-red for negative %
export const priceInfoData: PriceInfoItemProps[] = [
  {
    title: "Zcash Price Today: What you need to know",
    content: `
      <p>The price of Zcash (ZEC) now is <span class="text-accent-gold">$103.13</span></p>
      <p>Over the past 24 hours the price of Zcash has changed by <span class="text-accent-green">1.24%</span> from <span class="text-accent-gold">$102.12</span> to <span class="text-accent-gold">$104.43</span></p>
      <p>Over the past month the price of Zcash has changed by <span class="text-accent-red">-19.86%</span> from <span class="text-accent-gold">$201.23</span> to <span class="text-accent-gold">$104.12</span></p>
    `,
  },
  {
    title: "What is the year-to-date return for Zcash?",
    content: `
      <p>The price of Zcash (ZEC) now is <span class="text-accent-gold">$103.13</span></p>
      <p>Over the past 24 hours the price of Zcash has changed by <span class="text-accent-green">1.24%</span> from <span class="text-accent-gold">$102.12</span> to <span class="text-accent-gold">$104.43</span></p>
      <p>Over the past month the price of Zcash has changed by <span class="text-accent-red">-19.86%</span> from <span class="text-accent-gold">$201.23</span> to <span class="text-accent-gold">$104.12</span></p>
    `,
  },
  {
    title: "How far is current price from the all-time-high (ATH) price of Zcash?",
    content: `
      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to makeLorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
      <p>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make.</p>
    `,
  },
];


export default function PriceInfoItem({
  title,
  content,
}: PriceInfoItemProps): React.ReactElement {
  return (
    <div className="flex gap-[22px] items-start py-10 sm:py-[55px] border-b border-foreground/10 last:border-b-0">
      {/* Arrow Icon */}
      {/* <div className="mt-1">
        <PixelArrow />
      </div> */}

      {/* Content */}
      <div className="flex flex-col gap-[25px]">
        {/* Title */}
        <h3 className="text-foreground text-[18px] font-rubik font-medium leading-normal tracking-[-0.54px]"
        >
          {title}
        </h3>

        {/* Description with HTML */}
        <div
          className="text-foreground/80 text-[16px] space-y-[12px] font-normal leading-[24px] font-rubik"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
}

interface PriceInfoHtmlShellProps {
  contentHtml: string;
  proseClassName?: string;
}

/** Shared wrapper for CMS “about this chart” HTML (static or substituted). */
export function PriceInfoHtmlShell({
  contentHtml,
  proseClassName,
}: PriceInfoHtmlShellProps): React.ReactElement {
  return (
    <div className="aboutThisChart chart-seo-content lg:mt-6 w-full max-w-[845px] mx-auto">
      <div
        className={[
          "prose prose-invert max-w-none font-kode-mono text-[14px] text-foreground/70 py-10 sm:py-[55px]",
          proseClassName,
        ]
          .filter(Boolean)
          .join(" ")}
        dangerouslySetInnerHTML={{ __html: contentHtml }}
      />
    </div>
  );
}

interface PriceInfoSectionProps {
  content: string;
  proseClassName?: string;
}

export function PriceInfoSection({
  content,
  proseClassName,
}: PriceInfoSectionProps): React.ReactElement {
  return <PriceInfoHtmlShell contentHtml={content} proseClassName={proseClassName} />;
}
